import React from 'react';
import classNames from 'classnames';
import ButtonStyles from '../sass/partials/_timelineButton.module.scss';

export default class Timeline extends React.Component<{
  timelineOpen: boolean; changeTimelineOpen: Function
}, {}> {

  private changeIcon(): React.ReactElement {
    return (
      this.props.timelineOpen ? <i className={'fas fa-chevron-right'} /> :
        <i className={'fa fa-chevron-left'} />
    )
  }

  public render(): React.ReactElement {
    return (
      <button
        className={classNames(ButtonStyles.timelineButton,
          !this.props.timelineOpen ? [ButtonStyles.timelineOpen] :
            [ButtonStyles.timelineClosed])}
        onClick={(): void =>
          this.props.changeTimelineOpen(!this.props.timelineOpen)}
        data-cy="timeline-button"
        title="Open Timeline"
      >
        <div className={ButtonStyles.icon}>
          {this.changeIcon()}
        </div>
      </button>
    );
  }
}
